const Results = (results) => {
    const view = results.posts
      .map((result) => {
        if (result['term_link']) {
          var term = `<a href='${result['term_link']}' aria-label='${result['term_name']}'>${result['term_name']}</a>`;
        }

        if (result['link']) {
          var link =  `<div class="btn-wrapper"><a href="${result['link-url']}" class="btn btn-secondary" target="${result['link-target']}" aria-label="${result['link-title']}">${result['link-title']}</a></div>`;
        }

        var content = (result['result_content']) ? 
           `<div class="result-description">${result['result_content']}</div>` : "";

        return `
        <div class="result-item">
					<div class="h3 result-title">${result['result_title']}</div>
					<div class="h4 result-taxonomy">${term}</div>
          ${content}
          ${link}
        </div>
          `;
      })
      .join('');
    return view;
  };
  
  export default Results;